import Card from './../Card'
import {useState,useEffect} from 'react'
import "./RecipesDisplay.css"
export default function RecipesDisplay(){
    const [recipes,setRecipes]=useState([]);
    useEffect(()=>{
        fetch("https://dummyjson.com/recipes?limit=110&skip=0")
        .then(res=>res.json())
        .then(data=>setRecipes(data.recipes))
        .catch(err=>console.error(err))
    },[])
    return(
        <div className='RecipeDisplay'>
            {
                recipes.length>0?(
                    recipes.map((recipe)=>(
                        <Card
                        key={recipe.id}
                        id={recipe.id}
                        image={recipe.image}
                        name={recipe.name}
                        rating={recipe.rating}
                        preptime={recipe.prepTimeMinutes}
                        mealtype={recipe.mealType}
                        servings={recipe.servings}>
                        </Card>
                    ))
                ):(<p>Loading Recipes...</p>)
            }
        </div>
    )
}